import React from "react";
import Term from "../term";

const PrivacyPolicy = () => {
  return (
    <section id="privacy-policy">
      <h2>Privacy Policy</h2>
      <Term title="1. Scope" id="privacy-1">
        <p>
          PT EMOS Global Digital (EGD) is the official owner of the EMOS
          (Electronic Mobile Order System) Marketplace application and the
          website https://www.emos.id, as well as the manager and controller
          of the operations of both the application and the website. By
          accessing the EMOS Marketplace application or the EMOS website
          ("EMOS") provided by PT EMOS Global Digital ("EGD"), Users agree
          to be bound by this Privacy Policy.
        </p>
        <p>
          This Privacy Policy outlines the manner in which customer
          information is protected during the use of this service.
        </p>
      </Term>
      <Term title="2. Changes to the Privacy Policy" id="privacy-2">
        <p>
          EGD retains the authority to modify this Privacy Policy as needed,
          and any amendments will be communicated through this application
          or via email. Customers are encouraged to regularly review this
          page for updates. By continuing to access and utilize the services
          provided on this application and website, the Customer is
          considered to have accepted any modifications to this Privacy
          Policy.
        </p>
      </Term>
      <Term title="3. EMOS Usage Requirements" id="privacy-3">
        <ol className="list-style-alpha">
          <li>
            <p>
              Users of EMOS are obligated to provide accurate, truthful, and
              up-to-date information during registration and to promptly
              update any changes to their data through EMOS or other methods
              as stipulated by EGD provisions. The information required for
              registration includes:
            </p>
            <ol>
              <li>
                Official identity documents, as specified in the application
                options.
              </li>
              <li>
                A valid and active mobile phone number to facilitate the
                sending and receiving of SMS or WhatsApp messages to EMOS,
                or any other communication channels designated by EGD
                periodically.
              </li>
              <li>
                An active email address with adequate storage capacity.
              </li>
              <li>
                A smartphone or device that meets the Operating System (OS)
                requirements and minimum specifications established by EGD.
              </li>
            </ol>
          </li>
          <li>
            EMOS retains the right to modify and/or request Users to amend
            the data they have registered within EMOS.
          </li>
          <li>
            <p>
              When accessing EMOS, Users may enable the biometric login
              feature, utilizing the biometric capabilities of their
              smartphones. It is important to note that EGD is not liable
              for:
            </p>
            <ol>
              <li>
                The quality or security of the biometric feature, and/or
              </li>
              <li>
                Any negligence and/or misuse by the User and/or any third
                party regarding the biometric feature on the User's
                smartphone.
              </li>
            </ol>
          </li>
          <li>
            The password, redeem PIN, and authentication code are
            confidential credentials for which the User is entirely
            accountable. This includes any claims that may arise from third
            parties due to the misuse of these credentials, whether
            resulting from the User's intentional actions or negligence in
            their storage, usage, or management. The User's liability
            remains unless it can be demonstrated that such misuse was
            attributable to EGD's fault.
          </li>
          <li>
            The User must ensure that access to the application is
            controlled by refraining from sharing the password, redeem PIN,
            or authentication code with anyone other than themselves.
          </li>
        </ol>
      </Term>

      <Term title="4. Documentation Requests" id="privacy-4">
        <ol className="list-style-alpha">
          <li>
            Requests made through EMOS can only be submitted via a
            smartphone that has been verified in accordance with EGD's
            procedures and in compliance with ISO 27001 and relevant
            regulations, unless specific features or processes indicate
            otherwise.
          </li>
          <li>
            All submissions on EMOS are considered legally binding actions
            for the User, which cannot be revoked or contested.
            Consequently, it is the User's responsibility to ensure that
            their requests are accurate, complete, and correct. EGD is not
            required to verify or investigate the authenticity, validity, or
            authority of the smartphone or the authentication method
            employed.
          </li>
          <li>
            <p>
              EGD retains the right to deny a User's request on EMOS for the
              following reasons:
            </p>
            <ol>
              <li>Violation of applicable laws and regulations</li>
              <li>
                Exceeding the payment term limit for outstanding
                transactions
              </li>
              <li>
                Detection or suspicion of fraud or criminal activity by EMOS
              </li>
              <li>
                Technical issues at EGD or with third parties associated
                with EMOS
              </li>
              <li>Force majeure events</li>
              <li>
                Any other reasons deemed appropriate by EGD, including those
                aimed at safeguarding the interests of the User or EGD
              </li>
            </ol>
            <p>
              If mandated by applicable laws and regulations, EGD will
              notify the User regarding the reason for the denial of their
              request.
            </p>
          </li>
          <li>
            All requests are digitally recorded at EGD's data center. In the
            event of any discrepancies between the information provided to
            the User and that stored in EGD's data center, the records in
            EGD's data center will be considered authoritative, unless a
            court ruling states otherwise.
          </li>
        </ol>
      </Term>

      <Term title="5. Availability" id="privacy-5">
        <ol className="list-style-alpha">
          <li>
            EMOS reserves the right to determine the provision of different
            features for each User in accordance with applicable regulations
            or EGD's analysis of each User's market or risk profile.
          </li>
          <li>
            <p>EGD reserves the right to: </p>
            <ol>
              <li>
                Determine the operational time of feature availability in
                EMOS
              </li>
              <li>
                Determine the EMOS automatic logout time limit (idle time)
              </li>
              <li>
                Make modifications to EMOS including but not limited to
                features, design, and/or functionality
              </li>
              <li>
                EGD reserves the right to discontinue EMOS, in whole or in
                part, temporarily or for a period of time determined by EGD
                for the purpose of updating, maintenance, or for any other
                purpose for any reason EGD deems fit and for which EGD shall
                not be liable to anyone.
              </li>
            </ol>
          </li>
        </ol>
      </Term>

      <Term
        title="6. Blocking and Termination of EMOS Access"
        id="privacy-6"
      >
        <p>
          EGD reserves the right to block and/or terminate a User's access
          to EMOS, either in part or in full, temporarily or permanently,
          with or without prior notification to the User under the following
          circumstances:{" "}
        </p>
        <ol className="list-style-alpha">
          <li>
            The User inputs an incorrect password in accordance with EMOS
            guidelines.
          </li>
          <li>
            The User's account is deemed suspicious, malicious, or linked to
            criminal activities or civil disputes.
          </li>
          <li>
            The User breaches any aspect of the Privacy Policy, or the
            User's profile does not align with the characteristics of EMOS
            services.
          </li>
          <li>
            The User fails to update EMOS, or the smartphone being used is
            deemed incompatible as per EGD's provisions.
          </li>
          <li>
            EGD's evaluation, policies, and risk analysis require measures
            to protect the interests of both the User and EGD.
          </li>
          <li>
            EGD is compelled to act in compliance with relevant laws and
            regulations or directives from authorized agencies.
          </li>
        </ol>
      </Term>

      <Term title="7. Disclaimer" id="privacy-7">
        <ol className="list-style-alpha">
          <li>
            The User affirms that they possess the legal authority to
            consent to the Privacy Policy and any related agreements with
            EGD in accordance with applicable law.
          </li>
          <li>
            <p>By utilizing EMOS, the User confirms that:</p>
            <ol>
              <li>
                The User has thoroughly read, comprehended, and accepted the
                entirety of the EMOS Privacy Policy, including their rights
                and responsibilities, as well as the associated benefits and
                risks of using EMOS.
              </li>
              <li>
                EGD has provided the User with adequate time to read,
                understand, and consent to the complete EMOS Privacy Policy.
              </li>
              <li>
                The User's action of clicking the "Agree" button, or a
                similar option, serves as an electronic signature that
                carries binding legal implications for the User.
              </li>
            </ol>
          </li>
        </ol>
      </Term>

      <Term
        title="8. Governing Laws, Regulations, and Jurisdiction"
        id="privacy-8"
      >
        <ol className="list-style-alpha">
          <li>
            By using EMOS, the User acknowledges that this EMOS Privacy
            Policy is subject to and interpreted under the laws and
            regulations of the Republic of Indonesia.
          </li>
          <li>
            Any disagreements or issues that arise in connection with the
            enforcement of this Privacy Policy will be addressed through
            discussion.
          </li>
          <li>
            If any disagreements cannot be settled through discussion, they
            will be resolved by Lembaga Alternatif Penyelesaian Sengketa
            (LAPS) in accordance with regulatory guidelines.
          </li>
        </ol>
      </Term>

      <Term title="9. Severability" id="privacy-9">
        <p>
          Should any part of this Privacy Policy be deemed void, invalid,
          voidable, or unenforceable, the other provisions will remain
          intact and unaffected. Additionally, if an issue occurs with a
          specific feature, it will not necessarily impact the overall
          functionality of EMOS, unless it can be demonstrated that the
          issue constitutes a breach of this Privacy Policy.
        </p>
      </Term>

      <Term
        title="10. Compliance with Regulations for Online Medical Device Distribution"
        id="privacy-10"
      >
        <p>
          The EMOS Privacy Policy has been revised to align with relevant
          laws and regulations, including the Online Medical Supplies
          Distribution Regulation. The User acknowledges that they have read
          and comprehended this EMOS Privacy Policy, which outlines the
          User's rights and responsibilities, as well as the associated
          benefits and risks of using EMOS.
        </p>
      </Term>

      <Term title="11. Force Majeure" id="privacy-11">
        <p>
          EGD shall not be held responsible if it is unable to fulfill the
          User's order, either in whole or in part, due to circumstances
          beyond its control. This includes, but is not limited to, natural
          disasters, warfare, civil disturbances, system failures, power
          outages, communication disruptions, and/or changes in regulatory
          policies.
        </p>
      </Term>

      <Term title="12. Policy Update" id="privacy-12">
        <p>
          The EMOS User Data Protection Policy is effective as of 01
          November 2024.
        </p>
      </Term>
    </section>
  );
};

export default PrivacyPolicy; 